"use client";

import Icon from "@/components/icons";
import type { IconProps } from "@/components/icons/types";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

type InfoTooltipProps = {
  text: string;
  label: string;
  triggerClassName?: string;
  iconSvgProps?: IconProps["svgProps"];
};

export default function InfoTooltip({
  text,
  label,
  triggerClassName = "ml-2 relative top-1",
  iconSvgProps,
}: InfoTooltipProps) {
  return (
    <Popover>
      <PopoverTrigger className={triggerClassName} aria-label={label}>
        <Icon type="info" svgProps={iconSvgProps} />
      </PopoverTrigger>
      <PopoverContent className="bg-primary p-4 rounded-xl max-w-56 mx-auto text-white text-sm">
        {text}
      </PopoverContent>
    </Popover>
  );
}
